var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 112.2",
    style: {
      enableBackground: "new 0 0 70 112.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_15_",
    x: 20.9,
    y: 65.4,
    className: "st0",
    width: 29.5,
    height: 29.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_16_",
    className: "st1",
    x1: 9,
    y1: 64.2,
    x2: 60,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_94_",
    className: "st2",
    d: "M49.3,92.1c-3.2,0-4.1-1.2-4.3-2.2c-0.1-0.6,0-1.3,0.6-2.1c-1.4-0.6-1.7-1.8-1.8-2.2 c-0.2-1.3,0.6-2.6,2-3.7c-1-0.7-1.3-1.6-1.3-2.2c-0.2-2.4,2.5-4.7,5.2-5.3c0.9-0.2,1.8-0.3,2.8-0.3c4.4,0,8,2.6,8.7,6.3 c0.4,2.3-0.3,4.8-2.1,7c-2.2,2.8-5.7,4.7-8.9,4.9C49.8,92.1,49.5,92.1,49.3,92.1C49.3,92.1,49.3,92.1,49.3,92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_91_",
    d: "M52.5,75.4c3.7,0,6.7,2.2,7.2,5c0.9,4.8-4.6,9.8-9.6,10.1c-0.3,0-0.6,0-0.8,0c-4.1,0-3.7-2.2,0.8-4.1 c-0.7,0.1-1.4,0.2-2,0.2c-4.3,0-3.8-3.5,2-5.1c-6.9-0.4-3.8-4.9,0-5.8C50.9,75.5,51.7,75.4,52.5,75.4 M52.5,72.4 c-1,0-2.1,0.1-3.1,0.4c-3.4,0.8-6.7,3.6-6.4,6.9c0,0.5,0.2,1.2,0.7,2c-1.2,1.3-1.6,2.7-1.4,4c0.1,0.9,0.5,1.8,1.3,2.5 c-0.2,0.7-0.2,1.4-0.1,2c0.3,1.3,1.4,3.4,5.8,3.4c0.3,0,0.6,0,1,0c3.7-0.2,7.5-2.3,10-5.5c2-2.5,2.8-5.4,2.4-8.2 C61.8,75.6,57.6,72.4,52.5,72.4L52.5,72.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_89_",
    className: "st2",
    d: "M20.7,92.1c-0.3,0-0.6,0-0.9,0c-3.2-0.2-6.7-2.1-8.9-4.9c-1.7-2.2-2.5-4.7-2.1-7 c0.6-3.6,4.3-6.3,8.7-6.3c0.9,0,1.8,0.1,2.8,0.3c2.7,0.7,5.4,2.9,5.2,5.3c-0.1,0.6-0.3,1.5-1.3,2.2c1.5,1.1,2.2,2.3,2,3.7 c-0.1,0.4-0.4,1.6-1.8,2.2c0.6,0.8,0.7,1.6,0.6,2.1C24.8,90.9,23.9,92.1,20.7,92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    d: "M17.5,75.4c0.8,0,1.6,0.1,2.4,0.3c3.9,0.9,6.9,5.4,0,5.8c5.8,1.7,6.3,5.1,2,5.1c-0.6,0-1.2-0.1-2-0.2 c4.5,1.9,4.9,4.1,0.8,4.1c-0.3,0-0.5,0-0.8,0c-5-0.3-10.4-5.3-9.6-10.1C10.8,77.6,13.8,75.4,17.5,75.4 M17.5,72.4 C17.5,72.4,17.5,72.4,17.5,72.4c-5.1,0-9.4,3.2-10.1,7.5c-0.5,2.7,0.3,5.6,2.4,8.2c2.5,3.2,6.3,5.2,10,5.5c0.3,0,0.7,0,1,0 c4.4,0,5.5-2.1,5.8-3.4c0.1-0.6,0.1-1.2-0.1-2c0.8-0.7,1.2-1.6,1.3-2.5c0.2-1.2-0.2-2.7-1.4-4c0.5-0.8,0.6-1.5,0.7-2 c0.3-3.3-3-6.1-6.4-6.9C19.6,72.6,18.6,72.4,17.5,72.4L17.5,72.4z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.84e6532f2717e632c2025d4157644a23.svg";
export { ForwardRef as ReactComponent };